import React from 'react';
import classes from './publicationitem.module.css';

const PublicationItem = (props) => {
    return (
        <div className={classes.item}>
            <ul>
                <li>{props.pub}</li>
            </ul>

        </div>
    );
}

export default PublicationItem;